import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import InternalReportsViewModel from "viewModels/timeCharges/reporting/internalReports/internalReportsViewModel";
import Tabs from "../../../common/tabs";
import { IconType } from "@edaz/edazkit/Icon";
import Button from "@edaz/edazkit/Button/index";
import InternalReportsForm from "./internalReportsForm";
import BusinessReportsListViewModel from "viewModels/timeCharges/reporting/internalReports/businessReports/businessReportsListViewModel";
const InternalReportsView: ViewComponent<InternalReportsViewModel> = observer(({ vm }) => (
  <>
    <div className="d-flex justify-content-between">
      <h3 className="mb-4">{vm.name}</h3>
      {!(vm.activeChild instanceof BusinessReportsListViewModel) && vm.canMakeReport && (
        <Button className="d-block mb-md-3 rounded" size="sm" iconLeft={IconType.SignPlus} onClick={vm.onAddClick}>
          {vm.translate("create")}
        </Button>
      )}
    </div>
    {vm.createVM.addNew && <InternalReportsForm vm={vm.createVM} vmParent={vm} />}
    <Tabs vm={vm} />
  </>
));

registerView(InternalReportsView, InternalReportsViewModel);
